import { Pipe, PipeTransform } from '@angular/core';
import {
  FormAllData,
  FormSelectOption,
} from '../../interfaces/forms/form-element';
import { FieldService } from '../../services/field/field.service';

@Pipe({
    name: 'checkSelected',
    standalone: false
})
export class CheckSelectedPipe implements PipeTransform {
  constructor(private fieldService: FieldService) {}

  transform(
    option: FormSelectOption,
    { field, stepName }: { field: FormAllData; stepName: string }
  ): FormSelectOption {
    if (option.selected && field.name) {
      this.fieldService.setParams(
        field.name,
        { value: option.value },
        stepName
      );
    }
    return option;
  }
}
